export default "__VITE_PUBLIC_ASSET__b2e75714__"